import React from 'react';
import { Smartphone } from 'lucide-react';
import { Button } from './Button';
import { useNavigate } from 'react-router-dom';

export const CTA: React.FC = () => {
  const navigate = useNavigate();

  const handleGetApp = () => {
    navigate('/waiting-list');
  };

  return (
    <section className="py-24 px-4 md:px-6 bg-white">
      <div className="container mx-auto">
        <div className="bg-primary rounded-[3rem] p-10 md:p-24 relative overflow-hidden text-center shadow-2xl shadow-primary/30">
           {/* Decorative Background Elements matching Hero style */}
           <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-white/10 rounded-full blur-[80px] -translate-y-1/2 translate-x-1/2"></div>
           <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-blue-400/20 rounded-full blur-[60px] translate-y-1/2 -translate-x-1/2"></div>
           
           <div className="relative z-10 max-w-4xl mx-auto space-y-8">
             <h2 className="text-4xl md:text-6xl font-extrabold text-white leading-tight tracking-tight">
               Your Doctor is <br/>
               <span className="text-blue-200">One Tap Away</span>
             </h2>
             <p className="text-blue-50 text-xl max-w-2xl mx-auto font-medium leading-relaxed">
               Join thousands of men across Africa who have taken control of their health. Download the app today and get your first consultation started.
             </p>
             
             <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-8">
                <Button 
                  onClick={handleGetApp}
                  variant="white"
                  className="px-10 py-5 text-xl gap-3 text-primary shadow-2xl min-w-[260px]"
                >
                    <Smartphone size={24} strokeWidth={2.5} />
                    <span className="font-bold">Get the App</span>
                </Button>
             </div>
           </div>
        </div>
      </div>
    </section>
  );
};